module.exports = __webpack_public_path__ + "static/media/porductos_altena__artesanal_bolsa.7651d544.jpg";